import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useFilteredData } from '@ts-core/hooks/ui';

import { CourseStatus } from '@ts-core/utils/Constants';

export default function useCoursesList({
  courses: allCourses,
  loading,
  onSelectCourse,
  onRemoveCourse,
  onEditCourse,
  onAddCourse,
}) {
  const intl = useIntl();

  const {
    query: filterQuery,
    filteredData: courses,
    onFilterData: onFilterCourses,
  } = useFilteredData({
    list: allCourses,
    fields: ['name'],
  });

  const openCourses = useMemo(() => {
    return courses.filter((c) => c.periodStatus === CourseStatus.Active);
  }, [courses]);

  const closedCourses = useMemo(() => {
    return courses.filter((c) => c.periodStatus === CourseStatus.Closed);
  }, [courses]);

  const sections = useMemo(() => {
    const result = [];
    if (openCourses?.length > 0) {
      result.push({
        title: intl.formatMessage({ id: 'active.courses' }),
        courses: openCourses,
      });
    }
    if (closedCourses?.length > 0) {
      result.push({
        title: intl.formatMessage({ id: 'closed.courses' }),
        courses: closedCourses,
      });
    }
    return result;
  }, [intl, openCourses, closedCourses]);

  return {
    onSelectCourse,
    onRemoveCourse,
    onEditCourse,
    onAddCourse,
    onFilterCourses,
    loading,
    sections,
    filterQuery,
  };
}
